module.exports = __webpack_public_path__ + "img/katarina_living_room_6.817259e3.jpg";